export default __webpack_public_path__ + "static/media/100_31896.5fc5ff63.jpg";